<script lang="ts">
  import { getCurrency } from '@/framework/base/helpers/Localization';
  import Etablissement from '@/generated/classes/Etablissement';
  import Transaction, { TransactionStatuts, TransactionTypes } from '@/generated/classes/Transaction';
  import SectionReglementList from '@/generated/sections/SectionReglementList.vue';
  import { ColumnFilter, ListChoix } from '@/extend/classes/ListData';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  import Button from '@/framework/base/classes/Button';
  import Owner from '@/extend/classes/Owner';
  import { defineComponent, type PropType } from "vue";
  import DocumentType from "@/generated/classes/DocumentType.ts";
  import Document from "@/generated/classes/Document.ts";
  import { storeEtablissement } from '@/generated/stores';

  export default defineComponent({
    components: {},
    extends: SectionReglementList,
    props: {
      etablissement: {
        type: Object as PropType<Etablissement>,
        required: true
      }
    },
    data() {
      const buttons: Button[] = [];

      return {
        buttons,
        generatingBill: false,
      };
    },
    computed: {
      headers() {
        return [
          { text: "Date", value: 'dateTransaction', cellClass: '', sortable: true },
          { text: "Montant", value: 'amount', cellClass: '', sortable: true },
          { text: "Moyen", value: 'paymentMeans', cellClass: '', sortable: true },
          { text: 'Statut', value: 'statut', cellClass: '', sortable: true }
        ];
      },
      hasPayed(): boolean {
        let res = false;
        this.items.forEach((item) => {
          const transaction = item as Transaction;
          if (transaction.statut == TransactionStatuts.PAYED) {
            res = true;
          }
        });
        return res;
      },
      showSearch(): boolean {
        return false;
      },
      canAdd(): boolean {
        return false;
      },
      extraButtons(): Button[] {
        const facture = this.buttons[0] ?? new Button();
        facture.label = 'Générer facture';
        facture.show = true;
        facture.disabled = !this.hasPayed || this.generatingBill;
        facture.outlined = false;
        facture.loading = this.generatingBill;
        facture.callback = () => this.factureCallback(facture);
        if (this.buttons.length == 0) {
          this.buttons.push(facture);
        }
        return this.buttons;
      }
    },
    methods: {
      defaultFilter(): void {
        {
          const columnFilter = new ColumnFilter();
          const choix = new ListChoix();
          choix.value = this.etablissement.id;
          columnFilter.name = "ownerId";
          columnFilter.staticFilter = true;
          columnFilter.filters.push(choix);
          this.activeFilters.push(columnFilter);
        }
        {
          const columnFilter = new ColumnFilter();
          const choix = new ListChoix();
          choix.value = ObjTypes.ETABLISSEMENT;
          columnFilter.name = "ownerType";
          columnFilter.staticFilter = true;
          columnFilter.filters.push(choix);
          this.activeFilters.push(columnFilter);
        }
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "statut";
          columnFilter.staticFilter = true;
          {
            const choix = new ListChoix();
            choix.value = TransactionStatuts.WAITED;
            columnFilter.filters.push(choix);
          }
          {
            const choix = new ListChoix();
            choix.value = TransactionStatuts.PROCESSING;
            columnFilter.filters.push(choix);
          }
          {
            const choix = new ListChoix();
            choix.value = TransactionStatuts.RECEIVED;
            columnFilter.filters.push(choix);
          }
          {
            const choix = new ListChoix();
            choix.value = TransactionStatuts.EMITTED;
            columnFilter.filters.push(choix);
          }
          {
            const choix = new ListChoix();
            choix.value = TransactionStatuts.DELIVERED
            columnFilter.filters.push(choix);
          }
          {
            const choix = new ListChoix();
            choix.value = TransactionStatuts.PAYED;
            columnFilter.filters.push(choix);
          }
          {
            const choix = new ListChoix();
            choix.value = TransactionStatuts.WAITING_REJECT;
            columnFilter.filters.push(choix);
          }
          {
            const choix = new ListChoix();
            choix.value = TransactionStatuts.REJECTED;
            columnFilter.filters.push(choix);
          }
          {
            const choix = new ListChoix();
            choix.value = TransactionStatuts.WAITING_MANDAT;
            columnFilter.filters.push(choix);
          }
          this.activeFilters.push(columnFilter);
        }
      },
      getLabel(name: string, item: number, obj: unknown): string {
        const transaction = obj as Transaction;
        let res = item == 0 || item == null ? '' : item.toString();
        if (name == 'statut') {
          if (item == TransactionStatuts.PROCESSING) {
            res = 'En traitement';
          } else if (item == TransactionStatuts.WAITED) {
            res = "Attendu";
          } else if (item == TransactionStatuts.RECEIVED) {
            if (transaction.type == TransactionTypes.CARTE_BANCAIRE_RECU) {
              res = "Validée";
            } else {
              res = "Reçu";
            }
          } else if (item == TransactionStatuts.DELIVERED) {
            res = "Délivré";
          } else if (item == TransactionStatuts.EMITTED) {
            res = "Emis";
          } else if (item == TransactionStatuts.PAYED) {
            if (transaction.type == TransactionTypes.CARTE_BANCAIRE_RECU) {
              res = "Payée";
            } else {
              res = "Payé";
            }
          } else if (item == TransactionStatuts.BILLED) {
            res = "Facturé";
          } else if (item == TransactionStatuts.WAITING_REJECT) {
            res = "Délai rejet prélèvement";
          } else if (item == TransactionStatuts.REJECTED) {
            res = "Rejeté";
          } else if (item == TransactionStatuts.WAITING_MANDAT) {
            res = "Attente mandat";
          }
        } else if (name == 'amount') {
          res = getCurrency(item);
        } else if (name == "dateTransaction") {
          if (transaction.datePayed) {
            res = new Date(transaction.datePayed).toString();
          } else if (transaction.dateTransaction) {
            res = new Date(transaction.dateTransaction).toString();
          }
        } else {
          const column = this.listConfig.find(a => a.name == name);
          if (column) {
            const choix = column.choix.find(a => a.value == item);
            if (choix) {
              res = choix.text;
            }
          }
        }
        return res;
      },
      selectItem(event: any, row: any): void {
      },
      factureCallback(button: Button): Promise<void> {
        if (this.generatingBill) {
          return Promise.resolve();
        }
        this.generatingBill = true;
        button.disabled = true;
        button.loading = true;
        const owner = new Owner();
        owner.objType = ObjTypes.ETABLISSEMENT;
        owner.objId = this.etablissement.id;

        return storeEtablissement.updateEtablissement(this.etablissement)
          .then((etablissement: Etablissement) => {
            if (!etablissement.failed) {
              return Transaction.generateBill(owner);
            }
          })
          .finally(() => {
            this.generatingBill = false;
            button.loading = false;
          });
      }
    }
  })

</script>
